<div fxFlex="100" [formGroup]="matterdetailForm" class="kyc-container">
  <mat-checkbox formControlName="ISDESIGNATEDSERVICE" (change)="onCheckboxChange($event)">
    Is a Designated Service
  </mat-checkbox>
  @if (matterdetailForm.get('ISDESIGNATEDSERVICE')?.value) {
    <div class="kyc-title">
      {{
        matterdetailForm.get('CONTACTTYPE')?.value === 'Company'
          ? 'KYB Status for '
          : 'KYC Status for '
      }}{{ clientMatterText }}
    </div>
    <div class="kyc-inline-row">
      <div class="kyc-left-inline">
        <div class="kyc-status-row">
          <div class="kyc-icon-box">
            <img
              class="kyc-icon"
              [src]="
                getKycStatusIconPath(
                  $safeNavigationMigration(matterdetailForm.get('KYCSTATUS')?.value)
                )
              "
            />
          </div>
          <span class="kyc-text">
            {{
              getKycStatusText($safeNavigationMigration(matterdetailForm.get('KYCSTATUS')?.value))
            }}
            <span
              class="kyc-status"
              [ngClass]="
                getKycStatusClass(
                  $safeNavigationMigration(matterdetailForm.get('KYCSTATUS')?.value)
                )
              "
            >
              {{ matterdetailForm.get('KYCSTATUS')?.value }}
            </span>
          </span>
        </div>
        <button
          mat-raised-button
          color="primary"
          class="rounded! submit-smr-btn h-12! px-4! py-2!"
          (click)="submitSMR()"
        >
          Submit SMR
        </button>

        <!-- <div
          class="kyc-missing-hint"
          *ngIf="isInvalidContact && getKycMissingMessage() as msg">
          {{ msg }}
        </div> -->
      </div>
      @if (matterdetailForm.get('KYCSTATUS')?.value === 'Incomplete') {
        <div class="kyc-action-inline">
          <button
            mat-raised-button
            color="warn"
            (click)="openStartKybDialog()"
            class="btn-red rounded! h-12! px-4! py-2!"
            [matTooltip]="
              matterdetailForm.get('CONTACTTYPE')?.value !== 'Company' && !isKycReady
                ? kycTooltipMessage
                : ''
            "
            matTooltipPosition="above"
            [disabled]="
              (matterdetailForm.get('CONTACTTYPE')?.value !== 'Company' && !isKycReady) ||
              isKycLoading
            "
          >
            @if (isKycLoading) {
              <mat-spinner [style.zoom]="1" class="white-spinner" [diameter]="24"></mat-spinner>
            }
            @if (!isKycLoading) {
              <span>
                {{
                  matterdetailForm.get('CONTACTTYPE')?.value === 'Company'
                    ? 'Start KYB'
                    : 'Start KYC'
                }}
              </span>
            }
          </button>
          <button
            mat-raised-button
            color="primary"
            *ngIf="showKYBReportButton"
            (click)="downloadKYBReport()"
            [disabled]="isDownloadingKYBReport"
          >
            <mat-spinner
              *ngIf="isDownloadingKYBReport"
              diameter="20"
              class="white-spinner"
            ></mat-spinner>

            <span *ngIf="!isDownloadingKYBReport">Get KYB Report</span>
          </button>
        </div>
      }
      <!-- @if (showBiometricLink) {
                <div class="biometric-link-box">
                    <p class="mb-2"><strong>{{ matterdetailForm.get('CONTACTTYPE')?.value === 'Company'
        ? 'KYB link generated'
        : 'KYC link generated'
    }}
</strong></p>
                    <mat-form-field
                        appearance="outline"
                        class="full-width"
                    >
                        <input
                            matInput
                            [value]="biometricLink"
                            readonly
                        />
                        <span matSuffix>
                            <button
                                mat-icon-button
                                type="button"
                                class="copy-btn"
                                (click)="copyBiometricLink()"
                            >
                                <mat-icon class="copy-icon">file_copy</mat-icon>
                            </button>
                        </span>
                    </mat-form-field>
                </div>
            } -->
      <div class="kyc-right-inline">
        <span>
          Politically Exposed Person
          <b class="red">
            {{ matterdetailForm.get('POLITICALLYEXPOSEDPERSON')?.value || '-' }}
          </b>
        </span>
        <span>
          Foreign Entity
          <b class="red">
            {{ matterdetailForm.get('FOREIGNENTITY')?.value || '-' }}
          </b>
        </span>
        <span>
          Entity Type
          <b>
            {{ matterdetailForm.get('ENTITYTYPE')?.value || '-' }}
          </b>
        </span>
        <span>
          AML Risk Rating
          <b
            [ngClass]="
              getRiskClass($safeNavigationMigration(matterdetailForm.get('AMLRISKRATING')?.value))
            "
          >
            {{ matterdetailForm.get('AMLRISKRATING')?.value || '-' }}
          </b>
        </span>
      </div>
    </div>
    <!-- <mat-form-field appearance="outline" class="full-width">
    <mat-label>Source of Funds</mat-label>
    <textarea matInput rows="3" formControlName="SOURCEOFFUNDS"></textarea>
  </mat-form-field> -->
    <mat-form-field
      appearance="outline"
      fxFlex="100"
      class="full-width pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.NOTES),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.NOTES),
      }"
    >
      <mat-label>Source of Funds</mat-label>

      <textarea
        matInput
        formControlName="SOURCEOFFUNDS"
        rows="3"
        cdkTextareaAutosize
        cdkAutosizeMinRows="3"
        cdkAutosizeMaxRows="10"
        (keydown.enter)="$event.stopImmediatePropagation()"
      ></textarea>
    </mat-form-field>
  }
</div>
